import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { useVideoDataContext } from "../contexts/VideoDataContext";
import { checkIfVideoTypeLive } from "../utils/liveVideoUtils";
import { useAutoplayContext } from "../contexts/AutoplayContext";
import { LivePlayer } from "./LivePlayer";
import { LoopingPlayer } from "./LoopingPlayer";
import { VodPlayer } from "./VodPlayer";
import { OrcaOrYoutube } from "./OrcaOrYoutube";

// This is used by the full version of orca to determine which player to render based on the video type and autoplay state.
export const PlayerSelection = ({ forwardedRef, ...videoProps }) => {
  const { videoData } = useVideoDataContext();
  const { autoplayState } = useAutoplayContext();

  const { config = {} } = videoProps;

  const renderLivePlayer = checkIfVideoTypeLive(videoData);
  const renderLoopingPlayer = autoplayState.isLooping;

  const Player = useMemo(() => {
    if (renderLivePlayer) {
      return LivePlayer;
    }
    if (renderLoopingPlayer) {
      return LoopingPlayer;
    }
    return VodPlayer;
  }, [renderLivePlayer, renderLoopingPlayer]);

  return (
    <OrcaOrYoutube
      forwardedRef={forwardedRef}
      Player={Player}
      {...videoProps}
      config={config}
    />
  );
};

PlayerSelection.propTypes = {
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
